import React from "react";
import Link from "../../Link";

const Partner = props => {
  var s = props.settings,
    partnerImg = s["partner_logo"] ? s["partner_logo"] : "",
    partner = null,
    style = {};

  if (partnerImg.length > 0) {
    partnerImg =
      window.MEDIA_DOMAIN + "/" + partnerImg.replace(".", ",205,1000,0,0.");

    partner = (
      <div className="hp__box__footer">
        <h7 className="hp__box__logo__title col-xs-12 col-sm-12 ">
          {s.partner_label}
        </h7>
        <img
          alt="Partner artykułu"
          src={partnerImg}
          className="hp__box__logo col-xs-12 no-margin-padding old-centered"
        />
      </div>
    );
  }

  if (s["background_color"]) {
    style["backgroundColor"] = s["background_color"];
  }

  return (
    <Link to={s.link} className={props.classes} style={style}>
      {s.intro && (
        <h4 className="hp__box__title container col-sm-9 col-md-9 col-lg-12 old-centered">
          {s.intro}
        </h4>
      )}

      <p className="hp__box__content--special col-xs-12 col-sm-12">
        {s.content}
      </p>

      {partner}
    </Link>
  );
};

export default Partner;
